<!--MENU PADRAO-->
@if (isNotLogin()) {
  <div>
    @if (!isOptionFromNav()) {
      <nav class="container-fluid navbar navbar-expand-lg navbar-light bg-transparent mb-4">
        <div class="container-fluid">
          <a class="navbar-brand" [routerLink]="'/site'"><img src="./assets/site/LOGOS/JIANTAN.png" class="img-fluid logo" /></a>
          @if (!isNotHome()) {
            <a class="selo-click" (click)="openSelo()"><img src="./assets/site/ICONS/selo2024.png" class="selo bg-light" /></a>
          }
          <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-expanded="false">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse justify-content-end">
            @if (isNotLogin()) {
              <ul class="navbar-nav navbarmenugeral">
                <li class="nav-item">
                  <a class="nav-link" [routerLink]="'/site/sobre'">{{ 'Sobre' | translate }}</a>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{ 'Soluções' | translate }}</a>
                  <ul class="dropdown-menu"  aria-labelledby="navbarDropdown">
                    <li><a class="dropdown-item" (click)="scrollOnClick('divprodutorruralsolucao')">{{'Bônus de Remoção de Carbono para produtor rural' | translate}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="scrollOnClick('divempresassolucao')">{{'Bônus de Remoção de Carbono para empresas' | translate}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="scrollOnClick('divsindicatosolucao')">{{'Bônus de Remoção de Carbono para sindicatos e cooperativas' | translate}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="scrollOnClick('divselosolucao')">BRC - {{'Selo e certificado de qualidade e transparência' | translate}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="scrollOnClick('divplataformasolucao')">{{'Plataforma' | translate}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="scrollOnClick('divcalcsolucao')">{{'Calcule sua emissão de GEE(gases de efeito estufa)' | translate}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="scrollOnClick('divpalestrasolucao')">{{'Palestras' | translate}}</a></li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [routerLink]="'/site/projetos'">{{ 'Projetos' | translate }}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="https://blog.jiantan.com.br/">{{ 'Blog' | translate }}</a>
                </li>
              </ul>
            }
            <ul class="nav navbar-nav navbar-right navbarlinguas flex-nowrap ">
              <!-- MENU LINGUAGEM PARA COMPUTADOR-->
              <li class="nav-item d-none d-sm-block">
                <button class="nav-link" [disabled]="active" (click)="setActive()" [ngClass]="{'active': active}">PT</button>
              </li>
              <li class="nav-item d-none d-sm-block nav-link">|</li>
              <li class="nav-item d-none d-sm-block">
                <button class="nav-link" [disabled]="!active" (click)="setActive();" [ngClass]="{'active': !active}">EN</button>
              </li><!-- FIM MENU LINGUAGEM PARA COMPUTADOR-->
            </ul>
            @if (isNotLogin()) {
              <ul class="nav navbar-nav navbar-right gap-2 flex-lg-row flex-column">
                <li class="nav-item">
                  <a class="nav-link btn btn-warning btnfale btnmenu text-light" [routerLink]="'/site/faleconosco'" routerLinkActive="fale-conosco">{{ 'Fale Conosco' | translate }}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link btn btn-success btnmenu entrar text-light" (click)="navigateIfLoggedIn()">{{ 'Entrar' | translate }}</a>
                </li>
              </ul>
            }
          </div>
        </div>
      </nav>
    }
    <!--FIM MENU-->
    <!--MENU WHITE-->
    @if (isOptionFromNav()) {
      <nav class="container-fluid navbar navbar-expand-md navbar-light bg-transparent mb-4">
        <div class="container-fluid">
          <a class="navbar-brand" [routerLink]="'/site'"><img src="./assets/site/LOGOS/JIANTAN.png" class="img-fluid logo navbarmenugeral logo-branco" /></a>
          <button class="navbar-toggler custom-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-expanded="false">
            <span class="navbar-toggler-icon "></span>
          </button>
          <div class="collapse navbar-collapse justify-content-end">
            <ul class="navbar-nav navbar-right navbarmenugeral">
              <li class="nav-item">
                <a class="nav-link text-light" [routerLink]="'/site/sobre'" routerLinkActive="menu-type">{{ 'Sobre' | translate }}</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link text-light dropdown-toggle" routerLinkActive="menu-type"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ 'Soluções' | translate }}</a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" (click)="scrollOnClick('divprodutorruralsolucao')">{{'Bônus de Remoção de Carbono para produtor rural' | translate}}</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" (click)="scrollOnClick('divempresassolucao')">{{'Bônus de Remoção de Carbono para empresas' | translate}}</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" (click)="scrollOnClick('divsindicatosolucao')">{{'Bônus de Remoção de Carbono para sindicatos e cooperativas' | translate}}</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" (click)="scrollOnClick('divselosolucao')">BRC - {{'Selo e certificado de qualidade e transparência' | translate}}</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" (click)="scrollOnClick('divplataformasolucao')">{{'Plataforma' | translate}}</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" (click)="scrollOnClick('divcalcsolucao')">{{'Calcule sua emissão de GEE(gases de efeito estufa)' | translate}}</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" (click)="scrollOnClick('divpalestrasolucao')">{{'Palestras' | translate}}</a></li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-link text-light" [routerLink]="'/site/projetos'" routerLinkActive="menu-type">{{ 'Projetos' | translate }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link text-light" href="https://blog.jiantan.com.br/">{{ 'Blog' | translate }}</a>
              </li>
            </ul>
            <ul class="nav navbar-nav navbar-right navbarlinguas flex-nowrap">
              <!-- MENU LINGUAGEM PARA COMPUTADOR-->
              <li class="nav-item d-none d-sm-block">
                <button class="nav-link text-light" [disabled]="active" (click)="setActive()" [ngClass]="{'active': active}">PT</button>
              </li>
              <li class="nav-item d-none d-sm-block nav-link text-light">|</li>
              <li class="nav-item d-none d-sm-block">
                <button class="nav-link text-light" [disabled]="!active" (click)="setActive();" [ngClass]="{'active': !active}">EN</button>
              </li><!-- FIM MENU LINGUAGEM PARA COMPUTADOR-->
            </ul>
            <ul class="nav navbar-nav navbar-right gap-2 flex-lg-row flex-column">
              <li class="nav-item">
                <a class="nav-link btn btn-warning btnfale btnmenu text-light" [routerLink]="'/site/faleconosco'" routerLinkActive="fale-conosco">{{ 'Fale Conosco' | translate }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link btn btn-success btnmenu entrar text-light" (click)="navigateIfLoggedIn()">{{ 'Entrar' | translate }}</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    }
    <!--FIM MENU-->
    <!--SIDE MENU-->
    <div id="offcanvasNavbar" class="offcanvas offcanvas-end" tabindex="-1" aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-header p-5">
      </div>
      <div class="offcanvas-body">
        <div class="pb-5 d-flex justify-content-end">
          <button class="btn-close btn-close-white" type="button" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        @if (isNotLogin()) {
          <ul class="navbar-nav">
            <li class="nav-item p-2 border-bottom border-light">
              <a class="nav-link text-light" [routerLink]="'/site/sobre'" data-bs-dismiss="offcanvas">{{ 'Sobre' | translate }}</a>
            </li>
            <li class="nav-item p-2 border-bottom border-light dropdown dropdownoffcanvas">
              <a class="nav-link text-light dropdown-toggle" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">{{ 'Soluções' | translate }}</a>
              <ul class="dropdown-menu border border-light">
                <li><a class="dropdown-item text-light text-wrap border-bottom border-light" (click)="scrollOnClick('divprodutorruralsolucao')" data-bs-dismiss="offcanvas">{{'Bônus de Remoção de Carbono para produtor rural' | translate}}</a></li>
                <li><a class="dropdown-item text-light text-wrap border-bottom border-light" (click)="scrollOnClick('divempresassolucao')" data-bs-dismiss="offcanvas">{{'Bônus de Remoção de Carbono para empresas' | translate}}</a></li>
                <li><a class="dropdown-item text-light text-wrap border-bottom border-light" (click)="scrollOnClick('divsindicatosolucao')" data-bs-dismiss="offcanvas">{{'Bônus de Remoção de Carbono para sindicatos e cooperativas' | translate}}</a></li>
                <li><a class="dropdown-item text-light text-wrap border-bottom border-light" (click)="scrollOnClick('divselosolucao')" data-bs-dismiss="offcanvas">BRC - {{'Selo e certificado de qualidade e transparência' | translate}}</a></li>
                <li><a class="dropdown-item text-light text-wrap border-bottom border-light" (click)="scrollOnClick('divplataformasolucao')" data-bs-dismiss="offcanvas">{{'Plataforma' | translate}}</a></li>
                <li><a class="dropdown-item text-light text-wrap border-bottom border-light" (click)="scrollOnClick()" data-bs-dismiss="offcanvas">{{'Calcule sua emissão de GEE(gases de efeito estufa)' | translate}}</a></li>
                <li><a class="dropdown-item text-light text-wrap" (click)="scrollOnClick('divpalestrasolucao')" data-bs-dismiss="offcanvas">{{'Palestras' | translate}}</a></li>
              </ul>
            </li>
            <li class="nav-item p-2 border-bottom border-light">
              <a class="nav-link text-light" [routerLink]="'/site/projetos'" data-bs-dismiss="offcanvas">{{ 'Projetos' | translate }}</a>
            </li>
            <li class="nav-item p-2 border-bottom border-light ">
              <a class="nav-link text-light" [routerLink]="'/site/faleconosco'" data-bs-dismiss="offcanvas">{{ 'Fale Conosco' | translate }}</a>
            </li>
            <li class="nav-item p-2 border-bottom border-light">
              <a class="nav-link text-light" href="https://blog.jiantan.com.br/">{{ 'Blog' | translate }}</a>
            </li>
          </ul>
        }
        @if (isNotLogin()) {
          <ul class="nav navbar-nav navbar-right mt-5">
            <li class="nav-item">
              <a class="nav-link btn btn-success btnmenu btn-block text-light entrar" (click)="navigateIfLoggedIn()" data-bs-dismiss="offcanvas">{{ 'Minha conta' | translate }}</a>
              @if (!isLoggedIn()) {
                <a class="nav-link btn btnmenu btn-block text-light border border-light mt-2" [routerLink]="'/site/criarconta'" data-bs-dismiss="offcanvas">{{ 'Quero me cadastrar' | translate }}</a>
              }
            </li>
          </ul>
        }
        <div class="nav justify-content-center mt-5">
          <button class="nav-link text-light" [disabled]="active" (click)="setActive()" [ngClass]="{'active': active}">PT</button>
          <svg xmlns="http://www.w3.org/2000/svg" width="2" height="40" viewBox="0 0 2 40" fill="none">
            <path d="M1 0V40" stroke="#F8FCF9" />
          </svg>
          <button class="nav-link text-light" [disabled]="!active" (click)="setActive();" [ngClass]="{'active': !active}">EN</button>
        </div>
      </div>
    </div>
    <!--SIDE MENU-->
  </div>
}
